export default "__VITE_ASSET__39ROXEqH__"